module.exports = (__webpack_require__(67))(2);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/react-dom/cjs/react-dom.production.min.js from dll-reference vendor
// module id = 214
// module chunks = 41